import { EventDate } from '../types/ViewModel/EventDate';
import { EventDateBM } from '../types/BusinessModel/EventDateBM';
import { removeTimezoneOffset } from 'odfjell-date-time-utils/dateTimeUtils';

export class EventDateFactory {
    constructor() {}

    //   private removeTimezoneOffset(date: Date | null): Date | null {
    //     if (date) {
    //       var offset = date.getTimezoneOffset() / -60;
    //       date.setHours(date.getHours() + offset);
    //       var reminderInHours = (offset - Math.floor(offset)) * 60;
    //       date.setMinutes(date.getMinutes() + reminderInHours);
    //       return date;
    //     }
    //     return null;
    // }

    public newEventDate(eventDate: EventDateBM): EventDate {
        if (eventDate) {
            const plannedDateTimeUtc = removeTimezoneOffset(eventDate.plannedDateTimeUTC);
            const plannedDateTimeLocal = removeTimezoneOffset(eventDate.plannedDateTimeLocal);
            const actualDateTimeUtc = removeTimezoneOffset(eventDate.actualDateTimeUTC);
            const actualDateTimeLocal = removeTimezoneOffset(eventDate.actualDateTimeLocal);
            // const plannedDateTimeUtc = eventDate.plannedDateTimeUTC ? new Date(eventDate.plannedDateTimeUTC) : null;
            // const plannedDateTimeLocal = eventDate.plannedDateTimeLocal ? new Date(eventDate.plannedDateTimeLocal) : null;
            // const actualDateTimeUtc = eventDate.actualDateTimeUTC ? new Date(eventDate.actualDateTimeUTC) : null;
            // const actualDateTimeLocal = eventDate.actualDateTimeLocal ? new Date(eventDate.actualDateTimeLocal) : null;
            return new EventDate(plannedDateTimeUtc, plannedDateTimeLocal, actualDateTimeUtc, actualDateTimeLocal);
        }
        return new EventDate(null, null, null, null);
    }

    public createNewEventDate(
        plannedDateTimeUtc: Date | null,
        plannedDateTimeLocal: Date | null,
        actualDateTimeUtc: Date | null,
        actualDateTimeLocal: Date | null
    ): EventDate {
        const plannedDateTimeUtcTemp = plannedDateTimeUtc ? new Date(plannedDateTimeUtc) : null;
        const plannedDateTimeLocalTemp = plannedDateTimeLocal ? new Date(plannedDateTimeLocal) : null;
        const actualDateTimeUtcTemp = actualDateTimeUtc ? new Date(actualDateTimeUtc) : null;
        const actualDateTimeLocalTemp = actualDateTimeLocal ? new Date(actualDateTimeLocal) : null;
        if (actualDateTimeUtcTemp) {
            actualDateTimeUtcTemp.setSeconds(0, 0);
        }
        if (actualDateTimeLocalTemp) {
            actualDateTimeLocalTemp.setSeconds(0, 0);
        }
        if (plannedDateTimeUtcTemp) {
            plannedDateTimeUtcTemp.setSeconds(0, 0);
        }
        if (plannedDateTimeLocalTemp) {
            plannedDateTimeLocalTemp.setSeconds(0, 0);
        }
        return new EventDate(plannedDateTimeUtcTemp, plannedDateTimeLocalTemp, actualDateTimeUtcTemp, actualDateTimeLocalTemp);
    }

    public createEventDateFromCode(eventDate: EventDate): EventDate {
        return new EventDate(
            eventDate.plannedDateTimeUtc,
            eventDate.plannedDateTimeLocal,
            eventDate.actualDateTimeUtc,
            eventDate.actualDateTimeLocal
        );
    }

    public createEmptyEventDate() {
        return new EventDate(null, null, null, null);
    }

    public createEventDateBM(eventDate: EventDate): any {
        return {
            plannedDateTimeUTC: eventDate.plannedDateTimeUtc,
            plannedDateTimeLocal: eventDate.plannedDateTimeLocal,
            actualDateTimeUTC: eventDate.actualDateTimeUtc,
            actualDateTimeLocal: eventDate.actualDateTimeLocal,
        };
    }
}
